import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import {
  DEFAULT_LANGUAGE_CODE,
  normalizeLanguageCode,
  SUPPORTED_LANGUAGE_CODES,
} from 'config/languages';

export const resources = {
  en: en,
  fr: fr,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    detection: {
      convertDetectedLanguage: normalizeLanguageCode,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
